(() => {
  'use strict';

  const init = () => {
    window.nhStickyAtcCleanup?.();
    const bar = document.getElementById('royal-sticky-atc');
    const button = document.getElementById('royal-sticky-btn');
    const price = document.getElementById('royal-sticky-price-text');
    const page = document.querySelector('product-page.main-product');
    if (!bar || !button || !page) return;

    const mobile = window.matchMedia('(max-width: 768px)');
    const cart = document.getElementById('site-cart-sidebar');
    const footer = document.querySelector('.gem-footer-wrapper, footer, .main-footer');
    let frame = 0;
    let currentButton = null;
    let visible = false;

    const sync = () => {
      frame = 0;
      // Il rendering della sezione sostituisce pulsanti e prezzi: rileggili a ogni aggiornamento.
      currentButton = page.querySelector('form[data-type="add-to-cart-form"] [data-js-product-add-to-cart]');
      const busy = Boolean(page.querySelector('product-variants[aria-busy="true"]')) ||
        Boolean(currentButton?.classList.contains('working')) ||
        currentButton?.getAttribute('aria-busy') === 'true';
      const unavailable = !currentButton || currentButton.disabled ||
        currentButton.classList.contains('disabled') ||
        currentButton.getAttribute('aria-disabled') === 'true' ||
        Boolean(currentButton.closest('[inert]'));
      const originalPrice = page.querySelector('[data-update-block="price-extended"] .product-price--original, [data-update-block="price"] .product-price--original');
      const nextPrice = originalPrice?.textContent.trim() || '';
      if (price && price.textContent !== nextPrice) price.textContent = nextPrice;
      const originalLabel = currentButton?.querySelector('[data-js-product-add-to-cart-text]')?.textContent.trim();
      button.textContent = busy ? 'ATTENDI…' : (unavailable ? (originalLabel || 'NON DISPONIBILE') : 'AGGIUNGI');
      button.setAttribute('aria-busy', String(busy));

      const buttonRect = currentButton?.getBoundingClientRect();
      const footerRect = footer?.getBoundingClientRect();
      const footerVisible = footerRect && footerRect.top < window.innerHeight + 100 && footerRect.bottom > 0;
      const overlayOpen = cart?.classList.contains('sidebar--opened') || document.body.classList.contains('sidebar-opened');
      visible = Boolean(mobile.matches && buttonRect && buttonRect.bottom <= 0 && !footerVisible && !overlayOpen);
      bar.classList.toggle('is-visible', visible);
      bar.classList.toggle('is-hidden-override', Boolean(footerVisible || overlayOpen));
      bar.setAttribute('aria-hidden', String(!visible));
      bar.inert = !visible;
      button.tabIndex = visible ? 0 : -1;
      button.disabled = !visible || busy || unavailable;
      if (!visible && document.activeElement === button) button.blur();
    };

    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(sync);
    };
    const onClick = event => {
      event.preventDefault();
      // Ricontrolla subito, anche se la variante è cambiata nello stesso fotogramma.
      sync();
      if (!visible || button.disabled || !currentButton) return;
      // Il clic originale conserva ID selezionato, quantità, minimi e feedback del carrello.
      currentButton.click();
      sync();
    };

    const productObserver = new MutationObserver(schedule);
    productObserver.observe(page, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-busy', 'inert', 'value']
    });
    const overlayObserver = new MutationObserver(schedule);
    overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (cart) overlayObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    page.addEventListener('change', schedule);
    document.addEventListener('nh:cart-updated', schedule);
    button.addEventListener('click', onClick);
    sync();

    window.nhStickyAtcCleanup = () => {
      window.cancelAnimationFrame(frame);
      productObserver.disconnect();
      overlayObserver.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      mobile.removeEventListener('change', schedule);
      page.removeEventListener('change', schedule);
      document.removeEventListener('nh:cart-updated', schedule);
      button.removeEventListener('click', onClick);
    };
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
